import { media, Pagination, PaginationProps } from 'ia-react-core';
import { FC } from 'react';
import styled from 'styled-components';

export const StyledPagination = styled(Pagination as FC<PaginationProps>)`
  flex:1;
  margin: 0 auto;
  text-align: center !important;

  ${media.sm`
    margin: 0;
    flex: 0;
    margin-top: 0px;
  `};
`;
